var nurseslounge_myDashboard_continuingEducation = {
    tab_open:'recommended-education-by-specialty',
    init:function($params){
        var $tab = nurseslounge_myDashboard_continuingEducation.tab_open;
        nurseslounge_myDashboard_continuingEducation.ce_tabs_events($tab, function(){
            nurseslounge_myDashboard_continuingEducation.ce_list_pagination($tab);
        });
    },
    ce_tabs_events:function($tab, cback){
        var $allowTabs = [
            'recommended-education-by-specialty',
            'recommended-education-by-state',
            'all-education'
        ];
        var $cEList = $("#nurseslounge-home-continuing-education .continuing-education-list");
        var $homeCe = $("#nurseslounge-home-continuing-education");
        //Disable All
        $cEList.find('.nav-pills .nav-link').addClass('disabled').removeClass('active');
        $cEList.find('.tab-pane .continuing-education-content').html('');
        //Events
        $cEList.find('.nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, $allowTabs) > -1){
                if($selectedTab == 'all-education'){

                }
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination($selectedTab);
                //$("html, body").animate({scrollTop:$homeCe.offset().top});
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $cEList.find('.nav-pills .nav-link[data-target="#'+$v+'"]').removeClass('disabled');
        });
        $cEList.find('.nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if(cback != undefined){
            cback();
        }
    },
    ce_list_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=6; $i++){
            $chtml += '' +
                '<div class="col-md-6 preview">' +
                '    <a href="javascript:void(0)">' +
                '        <div class="card ce-card mb-4">' +
                '            <div class="ce-card-image ce-list-preload">' +
                '               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </div>' +
                '            <div class="ce-card-desc px-3 ce-list-preload">' +
                '                <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '            </div>' +
                '            <div class="ce-card-tags px-3 ce-list-preload">' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '    </a>' +
                '</div>';
        }
        return $chtml;
    },
    ce_list_pagination:function($tab, $rating, $hours, $states, $specialties, $title){
        nurseslounge_myDashboard_continuingEducation.tab_open = $tab;
        $rating = $rating == undefined ? '' : $rating;
        $hours = $hours == undefined ? '' : $hours;
        $states = $states == undefined ? '' : $states;
        $specialties = $specialties == undefined ? '' : $specialties;
        $title = $title == undefined ? '' : $title;
        var $reload;
        var $loaded = false;
        var $tabDiv = $("#"+$tab);
        var $cEContent = $tabDiv.find('.continuing-education-content:first');
        var $paginationNav = $tabDiv.find('.pagination-nav:first');
        var $resultInfo = $tabDiv.find('.result-info-count:first');
        var $paginationObj;
        var $data = $.extend({}, {
            user_id:libs.memoryGet('user_id'),
            tab:$tab,
            rating:$rating,
            hours:$hours,
            states:$states,
            specialties:$specialties,
            title:$title
        });
        try{
            $paginationObj = libs.memoryGet('continuing_education_list_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: 6,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/continuingEducation/lists",
            locator: 'data.continuing_education',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$data,
                beforeSend: function() {
                    $cEContent.html(nurseslounge_myDashboard_continuingEducation.ce_list_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('ce-list-preload');
                $resultInfo.removeClass('ce-list-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Continuing Education</span>');
                var $chtml = nurseslounge_myDashboard_continuingEducation.item_html($data);
                if($chtml != ''){
                    libs.checkImageLoad($($chtml).find('img'), function () {
                        $cEContent.html('').html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_continuingEducation.list_events($tab);
                        });
                    });
                }else{
                    var $txt = '';
                    switch ($tab) {
                        case 'recommended-education-by-specialty':
                            $txt = 'No recommended education found';
                            break;
                        case 'recommended-education-by-state':
                            $txt = 'No recommended education found';
                            break;
                        case 'all-education':
                            $txt = 'No education found ';
                            break;
                    }
                    $chtml = '' +
                        '<div class="col-12 mt-5">' +
                        '   <h5 class="w-100 text-center soft py-5 text-info">' +
                        $txt +
                        '   </h5>' +
                        '</div>';
                    $cEContent.html($chtml);
                }
            }
        });
        libs.memorySave('continuing_education_list_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination($tab, $rating, $hours, $states, $specialties, $title);
            }else{
                clearTimeout($reload);
            }
        }, 20000);
    },
    item_html:function($data){
        var $chtml = '';
        $.each($data, function($i, $v){
            var $id = $v.id;
            var $title = $v.title;
            var $description = $v.description_text;
            var $types = [];
            $.each($v.specialties, function($i, $sv){
                $types.push($sv.specialty.type);
            });
            var $states = [];
            $.each($v.states, function($i, $sv){
                $states.push($sv.state.state);
            });
            var $image = $v.image_root_widget;
            //var $link = $v.link;
            var $hours = $v.hours ? $v.hours : 0;
            var $rating = $v.rating ? $v.rating : 0;
            var $question = $v.questions ? $v.questions : 0;
            var $ceTags = [];
            if($types.length > 0) {
                $.each($types, function($i, $v){
                    $ceTags.push({tag:$v});
                });
            }
            if($states.length > 0) {
                $.each($states, function($i, $v){
                    $ceTags.push({tag:$v});
                });
            }
            if($hours > 0) {
                $ceTags.push({tag:'Hours '+$hours});
            }
            if($rating > 0) {
                $ceTags.push({tag:'Rating '+$rating});
            }
            if($question > 0) {
                $ceTags.push({tag:'Question '+$question});
            }
            $description = $description.length > 500 ? $description.substr(0, 500) + '...' : $description;
            $chtml += '' +
                '<div class="col-md-6 item" data-id="'+$id+'" ' +
                '>' +
                '   <div class="card ce-card mb-4 pb-5">' +
                '     <div class="ce-card-image">' +
                '         <img src="'+$image+'?resize=524x250" alt="continuing education image" class="img-fluid">' +
                '     </div>'+
                '     <div class="ce-card-desc px-3">' +
                '         <h3>'+$title+'</h3>'+
                '         <p>' + $description + '</p>' +
                //'         <button type="button" class="open-button m-3 float-right">' +
                //'             <i class="fa fa-book"></i>' +
                //'         </button>' +
                '     </div>' +
                '     <div class="ce-card-tags px-3">';
            $.each($ceTags, function($sI, $sV){
                $chtml += '<div class="tag">' + $sV.tag + '</div>';
            });
            $chtml += '' +
                '       <div class="row my-1">' +
                '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '       </div>' +
                '     </div>' +
                '   </div>' +
                '</div>';
        });
        return $chtml;
    },
    list_events:function($tab){
        var $cEList = $("#nurseslounge-home-continuing-education .continuing-education-list");
        var $cEContent = $cEList.find('.continuing-education-content');
        var $item = $cEContent.find('.item');
        $item.unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            nurseslounge_myDashboard_continuingEducation.open_ce({
                user_id:libs.memoryGet('user_id'),
                id:$id
            });
        });
        //Search Events
        var $keyPressBinding;
        var $cEAll = $("#nurseslounge-home-continuing-education");
        var $ceTab = $cEAll.find('#'+$tab);
        var $rating = $ceTab.find('select[name="rating"]');
        var $hours = $ceTab.find('select[name="hours"]');
        var $states = $ceTab.find('select[name="states"]');
        var $specialties = $ceTab.find('select[name="specialties"]');
        var $title = $ceTab.find('input[name="title"]');
        var $titleWrapper = $ceTab.find('.title-wrapper');
        $title.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $ratingVal = $rating.val();
            var $hoursVal = $hours.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $titleVal = $that.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    $tab,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $titleVal
                );
            }, 5000);
        });
        nurseslounge_myDashboard_continuingEducation.ce_autocomplete(
            $title,
            {
                tab:nurseslounge_myDashboard_continuingEducation.tab_open,
                user_id:libs.memoryGet('user_id')
            },
            "/myDashboard/continuingEducation/autocomplete",
            function($keyword){
                try{
                    clearTimeout($keyPressBinding);
                }catch ($e) {

                }
                var $ratingVal = $rating.val();
                var $hoursVal = $hours.val();
                var $statesVal = $states.val();
                var $specialtiesVal = $specialties.val();
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    nurseslounge_myDashboard_continuingEducation.tab_open,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $keyword
                );
            }
        );
        if($title.length > 0){
            $titleWrapper.removeClass('d-none');
            $titleWrapper.fadeIn();
        }
        try{
            $rating.chosen("destroy");
        }catch (e) {}
        $rating.chosen();
        $rating.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $ratingVal = $that.val();
            var $hoursVal = $hours.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $titleVal = $title.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    $tab,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $titleVal
                );
            }, 800);
        });
        if($rating.length > 0){
            $rating.fadeIn();
        }
        try{
            $hours.chosen("destroy");
        }catch (e) {}
        $hours.chosen();
        $hours.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $ratingVal = $rating.val();
            var $hoursVal = $that.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $titleVal = $title.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    $tab,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $titleVal
                );
            }, 800);
        });
        if($hours.length > 0){
            $hours.fadeIn();
        }
        try{
            $states.chosen("destroy");
        }catch (e) {}
        $states.chosen();
        $states.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $ratingVal = $rating.val();
            var $hoursVal = $hours.val();
            var $statesVal = $that.val();
            var $specialtiesVal = $specialties.val();
            var $titleVal = $title.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    $tab,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $titleVal
                );
            }, 800);
        });
        if($states.length > 0){
            $states.fadeIn();
        }
        try{
            $specialties.chosen("destroy");
        }catch (e) {}
        $specialties.chosen();
        $specialties.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $ratingVal = $rating.val();
            var $hoursVal = $hours.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $that.val();
            var $titleVal = $title.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_continuingEducation.ce_list_pagination(
                    $tab,
                    $ratingVal,
                    $hoursVal,
                    $statesVal,
                    $specialtiesVal,
                    $titleVal
                );
            }, 800);
        });
        if($specialties.length > 0){
            $specialties.fadeIn();
        }
    },
    ce_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    open_ce:function($data){
        $.ajax({
            url: "/myDashboard/myProfile/continuingEducation/visits",
            method: "POST",
            cache: false,
            dataType: "json",
            data: $data,
            success: function ($data) {
                if($data.data.continuing_education_link){
                    window.open($data.data.continuing_education_link+'?utm_source=affiliate&fpr=nurseslounge', '_blank', '');
                }
            }
        });
    },

};
